$shm_hitalama_map_widget_float_viewport_frame_number $mol_select
	Filter null
	Trigger_icon null
	Bubble_pane $mol_scroll
		sub /
			<= Items $mol_view
				sub <= menu_content
